import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Client } from 'src/app/models/client.model';
import { OrderModel } from 'src/app/models/order.model';
import { RefundLine, RefundModel } from 'src/app/models/refund.model';
import { QuantityDialogData, QuantityDialogPlainComponent } from 'src/app/pages/orders/edit/quantity-dialog/quantity-dialog.component';
import { SelectOrderClientComponent } from 'src/app/pages/orders/edit/select-order-client/select-order-client.component';
import { CurrentRefundService } from 'src/app/services/data/current-refund.service';

@Component({
  selector: 'app-refund-edit-info',
  templateUrl: './refund-edit-info.component.html',
  styleUrls: ['./refund-edit-info.component.scss'],
})
export class RefundEditInfoComponent implements OnInit, OnDestroy {
  @Input() order?: OrderModel;
  refund?: RefundModel;
  updChanges = false;
  subs: Subscription[] = [];
  minDate: Date;
  constructor(
    private returnCur: CurrentRefundService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 1);
  }

  ngOnInit(): void {
    const sub = this.returnCur.return$.subscribe((r) => {
      if (r) {
        this.refund = r;
        this.updChanges = false;
      }
    });

    this.subs.push(sub);
  }

  openClientDialog(): void {
    const dialogRef = this.dialog.open(SelectOrderClientComponent, {
      width: '90%',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result: Client) => {
      if (result && this.refund && this.refund?.buypointId !== result.id) {
        this.refund.buypoint = result.name;
        this.refund.buypointId = result.id;
        this.updChanges = true;
      }
    });
  }

  save() {
    if (this.refund) {
      this.returnCur.upd(this.refund).subscribe();
    }
  }

  deleteItem(goodId: string) {
    if (!this.refund || !goodId) return
    const ind = this.refund.items.findIndex(i => i.goodId === goodId);
    if (ind < 0) return
    this.refund.items.splice(ind, 1)
    this.returnCur.upd(this.refund).subscribe();
  }

  clickOnItem(line: RefundLine): void {
    const dd = {
      line: line,
      ok: false,
      ignoreMinPart: true,

    } as QuantityDialogData

    const dialogRef = this.dialog.open(QuantityDialogPlainComponent, {
      width: '600px',
      data: dd,
    })

    dialogRef.afterClosed().subscribe((result: QuantityDialogData) => {
      if (result?.line != undefined && result.line.amount != undefined && result.line.amount > 0 && result.ok) {

        this.returnCur.addOrUpdateItem(result.line)

      }
    })
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => {
      sub.unsubscribe();
    });
    this.subs = [];
  }
}
